import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import Loader from "../../components/loader";
import AuthRoutes from "./AuthRoutes";
// import Dashboard from "../../containers/Dashboard";
import Register from "../../containers/SignUp";
import Profile from "../../containers/SignUp/profile";
import AddPlant from "../../containers/SignUp/Addplant";
import Personalize from "../../containers/SignUp/personalize";
import SignIn from "../../containers/SignIn";
import ResetPassword from "../../containers/SignIn/restPassword";
import SetPassword from "../../containers/SignIn/setPassword";
import StorePreview from "../../containers/SignUp/storePreview";
import Newpassword from "../../containers/SignIn/newpassword";
import { Row, Col } from "antd";
import {
  AiOutlineTwitter,
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  AiOutlineYoutube,
} from "react-icons/all";
import Not_found from "../../containers/SignUp/not_found";
import { UserAction } from "../../store/actions";
import ExpiredLink from "../../containers/SignUp/expiredlink";
import StoreDown from "../../containers/SignUp/storedown";
import SurfaceTechLogo from "../../assets/images/surface-tech-logo.png";
import Rmx from "../../containers/Rmx";
import SurfaceLogo from "../../assets/images/surface-logo.png";

class Routes extends React.Component {
  componentDidMount() {
    const { getCompanyDetails, isAuthenticated } = this.props;
    if (isAuthenticated) {
      getCompanyDetails();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { contractorDetail, screenName } = this.props;
    // let userRole = data.role;

    console.log(
      "RMX_LOCATION==>",
      window?.location?.pathname?.includes("/rmx")
    );

    console.log("screenName==>", screenName);

    return (
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route exact path="/rmx" component={Rmx} />

          {!this.props.isAuthenticated ? (
            <React.Fragment>
              {!(
                !!window?.location?.pathname?.includes("expired_link") ||
                !!window?.location?.pathname?.includes("404")
              ) && (
                <Row justify="center">
                  <Col
                    span={screenName === "register" ? 24 : 20}
                    style={{
                      padding: "0.8rem",
                      position:
                        screenName === "register" ? "relative" : "absolute",
                      borderBottom: "solid white 2px",
                      background:
                        screenName === "register"
                          ? "rgb(56, 58, 61)"
                          : "transparent",
                    }}
                  >
                    <Row align="middle" justify="space-between">
                      <Col
                        xl={6}
                        lg={8}
                        md={8}
                        xs={24}
                        sm={24}
                        className="text-left"
                      >
                        <img width="60%" src={SurfaceLogo} />
                      </Col>
                      {screenName === "login" ? (
                        <Col xl={4} className="text-right">
                          {/* <Row className="text-right" justify="end">
                            <Col xl={4}>
                              <a
                                href="https://www.linkedin.com/company/10687685/"
                                target={"_blank"}
                              ></a>
                              <FaLinkedinIn color="white" size="25" />
                            </Col>

                            <Col xl={4}>
                              <a
                                target={"_blank"}
                                href="https://twitter.com/SurfaceTech_LLC"
                              >
                                <AiOutlineTwitter color="white" size="25" />
                              </a>
                            </Col>
                            <Col xl={4}>
                              <a
                                target={"_blank"}
                                href="https://www.facebook.com/Surface-Tech-211543822585857/"
                              >
                                <FaFacebookF color="white" size="25" />
                              </a>
                            </Col>
                            <Col xl={4}>
                              <a target={"_blank"}></a>
                              <FaInstagram color="white" size="25" />
                            </Col>
                            <Col xl={4}>
                              <a target={"_blank"}></a>
                              <AiOutlineYoutube color="white" size="25" />
                            </Col>
                          </Row> */}
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                  </Col>
                </Row>
              )}
              <Switch>
                <Route exact path="/404" component={Not_found} />

                <Route exact path="/register" component={Register} />
                <Route exact path="/profile" component={Personalize} />
                <Route exact path="/setpassword" component={SetPassword} />
                <Route exact path="/forgot" component={ResetPassword} />
                <Route exact path="/reset_password" component={Newpassword} />
                <Route exact path="/signin" component={SignIn} />
                <Route exact path="/expired_link" component={ExpiredLink} />
                <Route exact path="/store_down" component={StoreDown} />
                {/* <Route path="/" component={AuthRoutes} /> */}
                <Route path="*" render={() => <Redirect to="/signin" />} />
              </Switch>
            </React.Fragment>
          ) : (
            <>
              {!window?.location?.pathname?.includes("/rmx") ? (
                <Row>
                  <Col
                    span={24}
                    style={{ padding: "1rem", background: "#383A3D" }}
                  >
                    <Row align="middle" justify="space-between">
                      <Col xl={6}>
                        <img src={SurfaceLogo} height="20px" />
                      </Col>
                      <Col xl={18}>
                        <Row align="midlle">
                          <Col xl={23}>
                            <span>
                              <h4 className="color-white font-bold text-right">
                                Welcome{" "}
                                <span style={{ color: "orange" }}>
                                  {`${contractorDetail?.user?.first_name} ${contractorDetail?.user?.last_name}`}
                                </span>{" "}
                              </h4>
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col
                    span={24}
                    style={{ padding: "0.8rem", background: "#383A3D" }}
                  >
                    <Row align="middle" justify="space-between">
                      <Col xl={6} lg={8} md={8} xs={24} sm={24}>
                        <img width="60%" src={SurfaceLogo} height="20px" />
                      </Col>
                      <Col xl={12}>
                        <Row align="midlle">
                          <Col xl={4}>
                            <a
                              href="https://www.surface-tech.com/about-m/"
                              target="_blank"
                            >
                              <h4 className="color-white navbar-font-family">
                                ABOUT
                              </h4>
                            </a>
                          </Col>
                          <Col xl={4}>
                            <a
                              href="https://www.surface-tech.com/asphalt-overview-2/"
                              target="_blank"
                            >
                              <h4 className="color-white navbar-font-family ">
                                ASPHALT
                              </h4>
                            </a>
                          </Col>
                          <Col xl={4}>
                            <a
                              href="https://www.surface-tech.com/concrete_platform_2017/"
                              target="_blank"
                            >
                              <h4 className="color-white navbar-font-family ">
                                CONCRETE
                              </h4>
                            </a>
                          </Col>
                          <Col xl={7}>
                            <a
                              href="https://surface-tech.com/trkr-overview/"
                              target="_blank"
                            >
                              <h4 className="color-white navbar-font-family ">
                                SOFTWARE SOLUTIONS
                              </h4>
                            </a>
                          </Col>
                          <Col xl={5}>
                            <a
                              href="https://www.surface-tech.com/contact-2017/"
                              target="_blank"
                            >
                              <h4 className="color-white navbar-font-family ">
                                CONTACT
                              </h4>
                            </a>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={4}>
                        <Row>
                          <Col xl={4}>
                            <a
                              target={"_blank"}
                              href="https://twitter.com/SurfaceTech_LLC"
                            >
                              <AiOutlineTwitter color="white" size="25" />
                            </a>
                          </Col>
                          <Col xl={4}>
                            <a
                              target={"_blank"}
                              href="https://www.facebook.com/Surface-Tech-211543822585857/"
                            >
                              <FaFacebookF color="white" size="25" />
                            </a>
                          </Col>
                          <Col xl={4}>
                            <a
                              href="https://www.linkedin.com/company/10687685/"
                              target={"_blank"}
                            ></a>
                            <FaLinkedinIn color="white" size="25" />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}

              <div style={{ minHeight: "100vh", background: "#F7F7F7" }}>
                <Switch>
                  <Route path="/" component={AuthRoutes} />
                </Switch>
              </div>
            </>
          )}
        </Switch>
      </Suspense>
    );
  }
}

export default connect(
  (storeState) => {
    return {
      isAuthenticated: storeState.AuthReducer?.isAuthenticated,
      storeName: storeState.AuthReducer.storeInfo,
      contractorDetail: storeState.UserReducer.companyDetails,
      screenName: storeState?.AuthReducer?.screenName,
    };
  },
  (dispatch) => {
    return {
      getCompanyDetails: () => dispatch(UserAction.getCompantDetailReq()),
    };
  }
)(Routes);
